import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import de from "react-phone-input-2/lang/de.json";
import { toE164 } from "../../utils/phone";

const DIAL_CODES = ["41", "43", "49"];

// Bereitet eine gespeicherte Nummer für das Feld auf. Das Feld akzeptiert nur
// Eingaben, die mit der Vorwahl des gewählten Landes beginnen – ein Wert ohne
// gültige Vorwahl (z.B. Altdaten wie "2147483647") würde es sonst sperren.
const toInputDigits = (value) => {
  let digits = String(value ?? "").replace(/\D/g, "");
  if (digits.startsWith("00")) digits = digits.slice(2);
  else if (digits.startsWith("0")) digits = `41${digits.slice(1)}`;
  return DIAL_CODES.some((code) => digits.startsWith(code)) ? digits : "";
};

// Telefonfeld mit Länderauswahl (CH/AT/DE). Liefert den Wert immer im
// Format "+41791234567", so wie er in der Datenbank gespeichert wird.
export default function PhoneField({ value, onChange, invalid = false }) {
  return (
    <PhoneInput
      country="ch"
      onlyCountries={["ch", "at", "de"]}
      localization={de}
      countryCodeEditable={false}
      specialLabel=""
      value={toInputDigits(value)}
      onChange={(digits) => onChange(toE164(digits))}
      containerClass="!font-barlow"
      inputClass={`!w-full !h-[50px] !pl-14 !font-barlow !text-base !text-knapp-ink !bg-white !rounded-[10px] !border ${
        invalid ? "!border-knapp-accent" : "!border-knapp-borderInput"
      } focus:!border-knapp-ink !shadow-none`}
      buttonClass="!bg-white !border-knapp-borderInput !rounded-l-[10px] hover:!bg-knapp-surface"
      dropdownClass="!shadow-md !border-none !rounded-[10px] !font-barlow"
      inputProps={{ "aria-label": "Telefonnummer" }}
    />
  );
}
